import { render } from "./CardDetailViewAutoLoadCanvas.vue?vue&type=template&id=ae8a104c&scoped=true"
import script from "./CardDetailViewAutoLoadCanvas.vue?vue&type=script&lang=js"
export * from "./CardDetailViewAutoLoadCanvas.vue?vue&type=script&lang=js"

import "./CardDetailViewAutoLoadCanvas.vue?vue&type=style&index=0&id=ae8a104c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae8a104c"]])

export default __exports__